/**
 * Статус игры: оболочка узнаёт запущенную игру по процессам, клиент отправляет её
 * в шлюз (op 3), сервер разносит присутствием и пишет в историю «Активность».
 * В браузере ничего не происходит — узнавать игры оттуда нечем.
 *
 * Отправляем и при смене игры, и раз в минуту: на сервере статус живёт по TTL
 * и без напоминаний протух бы прямо во время игры.
 *
 * Показывать ли игру — настройка учётной записи (show_current_game в настройках на сервере):
 * от неё зависит и история, и второй компьютер. До 25.09.2026 она жила только в оболочке
 * (shareGame). Кто выключил её там, тому переносим «выключено» на сервер один раз, а в оболочке
 * возвращаем значение по умолчанию — дальше решает сервер.
 */
import { desktop } from './desktop'
import { gatewayClient } from './gatewaySingleton'
import { usePresenceStore } from '@/store/presence'

const REFRESH = 60_000

export function startGameStatus(): () => void {
  const shell = desktop
  if (!shell?.onGame || !shell.currentGame) return () => undefined

  let game: { name: string; steamAppId?: string } | null = null
  // пока не ясно, не выключена ли игра в оболочке по-старому, ничего не шлём
  let ready = false
  // перенос не удался (нет связи) — до следующего запуска всё равно не показываем
  let localOff = false
  const push = () => {
    if (!ready) return
    const show = usePresenceStore.getState().showGame && !localOff
    gatewayClient()?.setActivity(show ? game : null)
  }

  const offGame = shell.onGame((next) => {
    game = next
    push()
  })
  void shell.currentGame().then((next) => {
    game = next
    push()
  })
  // выключили здесь, на другом устройстве или с сервера пришли настройки — сразу снимаем или возвращаем игру
  const offSetting = usePresenceStore.subscribe((s, prev) => {
    if (s.showGame !== prev.showGame) push()
  })
  void shell
    .getSettings()
    .then(async (s) => {
      if (s.shareGame !== false) return
      localOff = true
      await usePresenceStore.getState().setShowGame(false)
      // сервер теперь не покажет игру сам — местный флаг больше не нужен
      localOff = false
      await shell.setSettings({ shareGame: true })
    })
    .catch(() => undefined)
    .finally(() => {
      ready = true
      push()
    })

  const timer = setInterval(push, REFRESH)

  return () => {
    offGame()
    offSetting()
    clearInterval(timer)
    gatewayClient()?.setActivity(null)
  }
}
